import { getGewerk } from '../../../main/functions/getGewerk';
import { i18n } from '../../../i18n/i18n';
import { IDs } from '../../../helpers/IDs';
import { SectionStyle } from '../../../helpers/SectionStyle';

const lineColorSpeziell = ['#728a49', '#de863f', '#6f91be', '#51bd75', '#5163bd', '#9951bd', '#bd5175', '#bd5151'];
export { lineColorSpeziell };

export function getKennziffernSpeziell(kenn_def: any[], baseWidth: number, mode?: string): any {
    const speziell: any = {};
    speziell.blocks = [];
    speziell.kuerzel = [];
    speziell.diags = [];

    kenn_def.forEach((kd: any) => {
        const baseTerm = i18n((!mode || mode === 'verbrauch') ? 'Energieeinsatz' : 'Energiekosten', 'sys');
        const baseUnit = (!mode || mode === 'verbrauch') ? 'kWh' : '€';
        const column1 = { label2: kd.einheit, customStyleLabel2: { borderTop: '0pt solid #fff' } };
        const column2 = { label2: baseUnit + ' / ' + kd.einheit, customStyleLabel2: { borderTop: '0pt solid #fff' } };
        const block1 = {
            label: kd.name,
            width: (baseWidth * 1) + '%',
            columns: [column1]
        };
        const block2 = {
            label: baseTerm + ' / ' + kd.name,
            width: (baseWidth * 1) + '%',
            columns: [column2]
        };
        const diag = getDiagrammDefinition(baseTerm + ' / ' + kd.name, baseUnit + ' / ' + kd.einheit);
        speziell.kuerzel.push(kd.kuerzel);
        speziell.blocks.push(block1);
        speziell.blocks.push(block2);
        if (speziell.diags.length < 2) {
            speziell.diags.push(diag);
        }
    });
    return speziell;
}

export function findKennziffernSpeziell(data: any, mode: string): any {
    const gewerk = getGewerk(data);
    const kenn_def = (data[IDs.ENT_KENNZAHLEN_DEFINTION] || [])
        .filter((k_def: any) => k_def.branchen_gewerke_tid_orig === gewerk
            && k_def.is_gewerk
            && k_def.is_gewerk === 1
            && (!k_def.is_berechnet || k_def.is_berechnet === 0)
        );
    const kenn_dyn = ((data || {})[IDs.ENT_KENNZAHLEN_DYNAMISCH] || []).filter((k_def: any) => k_def['auswertung_' + mode] === 1);
    return [...kenn_def, ...kenn_dyn];
}

export function hasKennzahlenSpez(data: any, mode: string, standort?: number): boolean {
    data = data || {};
    let hasData: boolean = false;
    const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort]
        || data[IDs.KENNZIFFERN_BERECHNET] || {};
    const kennzahlenSpez: any[] = (findKennziffernSpeziell(data, mode) || [])
        .map((item: any) => item.kuerzel || null);
    const startjahr: number = ((data[IDs.ENT_KONFIGURATION] || [])
        .find((item: any) => item.startjahr_datenerfassung) || {}).startjahr_datenerfassung || null;
    const jahrMax: number = new Date().getFullYear() - 1;
    const jahrMin: number = +startjahr > 1900 ? startjahr : 2010;

    for (let jahr = jahrMin; jahr <= jahrMax; ++jahr) {
        kennzahlenSpez.forEach((kuerzel: string) => {
            if (hasData = Object.keys(kennzahlen).some((key: any) => (+(kennzahlen[key] || {})[kuerzel] || 0) > 0)) {
                return;
            }
        });

        if (hasData) {
            break;
        }
    }
    return hasData;
}

function getDiagrammDefinition(name: string, einheit: string): any {
    const color: any = SectionStyle.getSectionColors() || {};
    lineColorSpeziell[0] = color.datenauswertung || '#4f81bd';
    lineColorSpeziell[1] = color.zusatztools || '#f79646';
    lineColorSpeziell[2] = color.dateneingabe || '#87bd51';
    // lineColorSpeziell[3] = color.informationen_hilfe || '#51bd75';
    return {
        title: name,
        titlePdf: name,
        legend: [name + ' [' + einheit + ']'],
        unit: ['%', '%', '%'],
        X_dataKey: 'jahr',
        Y_dataKey: ['wert'],
        data: [1, 2, 3],
        tickPeriod: [5, 5],
        singleYAxis: true,
        lineColor: lineColorSpeziell,
        containerSize: {
            width: '90%'
        }
    };
}
